// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"4225":"f39f6afe106d9320","6284":"adc65e9a04725eb9","6793":"7a55cdf94fc5b8c7"}[chunkId] + ".js";
};